<template>
  <div>
    <div v-if="cell_feature">
      <v-row class="ma-0 pa-0 align-center" no-gutters :style="topRowStyle">
        <v-col class="mx-2">
          <slot name="topLeft"></slot>
        </v-col>
        <v-col class="text-center mx-2" style="pointer-events: auto">
          Cell: {{ cell_feature.properties.id }}
        </v-col>
        <v-col class="mx-2 d-flex justify-end" style="pointer-events: auto">
          <v-checkbox
            id="row-tiles-add-remove-all"
            :disabled="cell_feature.properties.matches.length === 0"
            dense
            v-model="parentModel[cell_feature.properties.id]"
            :label="parentLabel(parentModel, cell_feature.properties.id)"
            @change="
              parentAction(
                parentModel,
                cell_feature.properties.id,
                cell_feature.properties.matches
              )
            "
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row
        class="ma-0 pa-0 align-center"
        no-gutters
        v-if="
          !Array.isArray(cell_feature.properties.matches) ||
          cell_feature.properties.matches.length === 0
        "
      >
        <v-col class="text-center pa-8 text--secondary"
          >No available tiles</v-col
        >
      </v-row>
      <v-slide-group
        id="row-tiles-slide"
        class="ps-4"
        active-class="success"
        show-arrows
        :key="cell_feature.properties.id"
        v-else
      >
        <v-slide-item
          v-for="match in cell_feature.properties.matches"
          v-bind:key="`${match.acquisition_id}${cell_feature.properties.id}`"
          class="mx-2 mb-1"
        >
          <tile-preview :match="match" :cell_feature="cell_feature" />
        </v-slide-item>
      </v-slide-group>
    </div>
    <v-row class="ma-0 pa-0 align-center" no-gutters v-else>
      <v-col class="text-center pa-8 text--secondary"
        >Please select a grid cell on the map to view available tiles for that
        cell</v-col
      >
    </v-row>
  </div>
</template>

<script>
import TilePreview from "./TilePreview.vue";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const cartStore = createNamespacedHelpers("shoppingCart");

export default {
  props: ["cell_feature", "topRowStyle"],
  components: { TilePreview },
  computed: {
    store() {
      return this.$store.state.shoppingCart.cart;
    },
  },
  watch: {
    store(newStore, oldStore) {
      this.syncParentModel();
    },
    cell_feature(newCellFeature, oldCellFeature) {
      this.syncParentModel();
    },
  },
  setup() {
    const { addToCart } = cartStore.useMutations(["addToCart"]);
    const { removeFromCart } = cartStore.useMutations(["removeFromCart"]);
    return { addToCart, removeFromCart };
  },
  data() {
    return {
      parentModel: {},
    };
  },
  mounted() {
    // check if parent should be checked
    this.syncParentModel();
  },
  methods: {
    parentLabel(model, cell_id) {
      if (model[cell_id]) {
        return "remove all cell tiles from cart";
      } else {
        return "add all cell tiles to cart";
      }
    },
    parentAction(parentModel, cell_id, tiles) {
      // sync order cart selection with checkbox selections
      tiles.forEach((tile) => {
        let id = `${cell_id}_${tile.acquisition_id}`;
        if (parentModel[cell_id]) {
          this.addToCart({
            cell: cell_id,
            id: id,
            name: tile.acquisition_id,
          });
        } else {
          this.removeFromCart({
            cell: cell_id,
            id: id,
            name: tile.acquisition_id,
          });
        }
      });
    },
    syncParentModel() {
      if (this.cell_feature) {
        this.parentModel = {};
        let cellTotal = this.cell_feature.properties.matches.length;
        let childCount = 0;

        this.$store.state.shoppingCart.cart.forEach((tile) => {
          if (tile.cell == this.cell_feature.properties.id) {
            childCount += 1;
          }
        });

        if (childCount == cellTotal) {
          this.parentModel[this.cell_feature.properties.id] = true;
        } else {
          this.parentModel[this.cell_feature.properties.id] = false;
        }
      }
    },
  },
};
</script>
